import React from 'react'
import PropTypes from 'prop-types'

export class DeliveryHourEditRowRemover extends React.Component {

  constructor(props){
    super(props)
    this.onDeliveryHourRemoverClicked = this.onDeliveryHourRemoverClicked.bind(this)
  }

  onDeliveryHourRemoverClicked(){
    let newDeliveryTimeSlots = this.props.row.poolTimes
    newDeliveryTimeSlots.splice(this.props.index, 1)
    this.props.onChange({
      ...this.props.row,
      poolTimes: newDeliveryTimeSlots
    },
    this.props.dayName)
  }

  render() {
    return <button className="editRowButton" name="deliveryHourRemover" title="remove delivery hours" onClick={this.onDeliveryHourRemoverClicked} >Remove</button>
  }
}

DeliveryHourEditRowRemover.propTypes = {
  row: PropTypes.shape({
    poolTimes: PropTypes.arrayOf(PropTypes.shape({
      startTime: PropTypes.string,
      endTime: PropTypes.string
    })).isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  dayName: PropTypes.string
}

DeliveryHourEditRowRemover.defaultProps = {
  dayName: ''
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourEditRowRemover.js